import {message} from 'antd'

export function emptyValidate(value, msg){
    if (!value) {
        message.error(msg)
        return true;
    }

    return false;
}